import { AppFeatures } from 'types/app';

export const getAppFeatures = (features: Record<string, string>): AppFeatures =>
  Object.fromEntries(
    Object.entries(features).reduce(
      (acc, [k, v]) => (k.startsWith('app.') ? [...acc, [k.split('.')[1], v.toLowerCase() === 'true']] : acc),
      [] as Array<[string, boolean]>,
    ),
  ) as unknown as AppFeatures;
